import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { CastProvider } from '../context/CastContext';
import { AgentGallery } from './AgentGallery';
import { AgentViewer } from './AgentViewer';
import { AgentCreator } from './AgentCreator';
import { JobMonitor } from './JobMonitor';
import ThemeSwitcher from '../../../basic/ThemeSwitcher';
import { useTheme } from '../../../basic/ThemeProvider';
import Typography from '../../../basic/Typography';
import styles from '../Cast.module.css';

export const CastPage: React.FC = () => {
  const navigate = useNavigate();
  const { isDark, toggleTheme } = useTheme();

  // Handle navigation back to main page products section
  const handleBackToMain = () => {
    navigate('/#products');
  };

  return (
    <CastProvider>
      <div className={styles['cast-page']}>
        <div className={styles['cast-header']}>
                  <div className={styles['cast-header-left']}>
          <button className={styles['geb-logo-button']} onClick={handleBackToMain}>
            <img src="/game/logo.png" alt="GEB Logo" className={styles['geb-logo-image']} />
          </button>
          <Typography variant="h1" className={styles['cast-title']} gutterBottom={false}>
            Cast Management
          </Typography>
        </div>
          <div className={styles['cast-header-right']}>
            <ThemeSwitcher isDark={isDark} onToggle={toggleTheme} />
          </div>
        </div>

        <div className={styles['cast-content']}>
          <Routes>
            <Route path="/" element={<AgentGallery />} />
            <Route path="/create" element={<AgentCreator />} />
            <Route path="/:agentId" element={<AgentViewer />} />
            <Route path="/jobs/:jobId" element={<JobMonitor />} />
          </Routes>
        </div>
      </div>
    </CastProvider>
  );
};

export default CastPage;